/**
 * Factory method for instantiating a Histogram.
 */
export default function () {

  // Default value function returns the value. This can be overridden to return a value from an
  // object.
  let _valueFn = value => value;

  // Default number of bins is 1.
  let _binCount = 1;

  // Default threshold function puts everything in a single bin.
  let _thresholdFn = () => 1;

  function histogram(hashMap) {

    // Initialise the bins.
    const bins = new Array(_binCount);
    for (let i = 0; i < _binCount; i++) {
      bins[i] = [];
    }

    // Assign data to bins. The value function is used to interpret the data, and the threshold
    // function is used to assign to a bin.
    Object.keys(hashMap).forEach((key) => {
      const value = _valueFn(hashMap[key]);
      const binIndex = _thresholdFn(value);
      const bin = bins[binIndex];
      if (bin) {
        bin.push(value);
      }
    });

    // Calculate a normalised count for each bin based on the total number of data items.
    const totalDataCount = Object.keys(hashMap).length;
    for (let binIndex = 0; binIndex < bins.length; binIndex++) {
      const bin = bins[binIndex];
      bin.normalisedCount = (totalDataCount > 0 ? bin.length / totalDataCount : 0);
    }

    // Return the bins.
    return bins;
  }

  /**
   * Override the value function.
   */
  histogram.value = (valueFn) => {
    _valueFn = valueFn;
    return histogram;
  };

  /**
   * Override the bin count.
   */
  histogram.binCount = (count) => {
    _binCount = count;
    return histogram;
  };

  /**
   * Override the threshold function.
   */
  histogram.thresholds = (thresholdFn) => {
    _thresholdFn = thresholdFn;
    return histogram;
  };

  return histogram;
}



// WEBPACK FOOTER //
// ./src/app/utils/histogram.js